import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";

function UpdateCoupon() {

    // 
    const token = sessionStorage.getItem('tokenKey');
    const navigate = useNavigate();
    const location = useLocation();
    const product = location && location.state;
    const BASE_URL = process.env.REACT_APP_PP_URL;

    const [couponCode, setCouponCode] = useState(product.couponCode);
    const [description, setDescription] = useState(product.description);
    const [startDate, setStartDate] = useState(product.startDate);
    const [endDate, setEndDate] = useState(product.endDate);
    const [discountType, setDiscountType] = useState({ value: product.discountType, label: product.discountType });
    const [minOrderValue, setMinOrderValue] = useState(product.minOrderValue);
    const [discountValue, setDiscountValue] = useState(product.discountValue);
    const [maxDiscountAmount, setMaxDiscountAmount] = useState(product.maxDiscountAmount);
    const [maxUsePerUser, setMaxUsePerUser] = useState(product.maxUsePerUser);
    const [referralCoupon, setReferralCoupon] = useState(product?.referralCoupon);
    const [shippingCoupon, setShippingCoupon] = useState(product?.shippingCoupon);

    const content = {
        // title: title,
        couponCode: couponCode,
        description: description,
        startDate: startDate,
        endDate: endDate,
        ...(!shippingCoupon && { discountType: discountType?.value }),
        minOrderValue: minOrderValue,
        discountValue: discountValue,
        ...(!shippingCoupon && { discountValue: discountValue }),
        ...(discountType?.value === 'Percentage' && !shippingCoupon && { maxDiscountAmount: maxDiscountAmount }),
        maxUsePerUser: maxUsePerUser,
        referralCoupon: referralCoupon,
        shippingCoupon: shippingCoupon
    }
    const [isSubmitting, setIsSubmitting] = useState(false);
    const members = async (uuid) => {
        if (isSubmitting) return; // prevent multiple rapid clicks

        setIsSubmitting(true);
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/couponCode/update/${uuid}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAction('Coupon Updated successfully !');
                setShowPop(true);
                setNavv('ok');
                setMore();
            } else {
                setShowPop(true);
                setAction('something went wrong');
                setNavv('OK');
                setMore('cancel');
            }
        } catch (e) {
            console.log(e, 'error in member api')
        } finally {
            setIsSubmitting(false);
        }
    };

    const [showPop, setShowPop] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();

    const navToCat = useNavigate();
    const confirmPopUp = () => {
        if (navv === 'ok') {
            setShowPop(false);
            navToCat('/admin/gift');
        } else if (navv === 'OK') {
            setShowPop(false);
        }
    };

    const onCloseBtn = () => {
        if (more === 'Add more') {
            setShowPop(false);
            setCouponCode('');
            setDescription('');
            setStartDate('');
            setEndDate('');
            setDiscountType('');
            setDiscountValue('');
            setMinOrderValue('');
            setMaxDiscountAmount('');
            setMaxUsePerUser('');

            window.scrollTo({
                top: 0,
                behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
            });
        } else if (more === 'cancel') {
            navToCat('/admin/gift');
        }
    };



    const handelStartDate = async (e) => {
        const getDate = e.target.value
        await setStartDate(getDate)
        if (endDate && new Date(endDate) < new Date(getDate)) {
            const trikh = new Date(getDate)
            trikh.setDate(trikh.getDate() + 1)
            setEndDate(trikh.toISOString().split('T')[0]);
        }
    };

    const stDate = new Date().toISOString().split('T')[0];

    const [showSuggestion, setShowSuggestion] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setShowSuggestion(false);
            };
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);

    const disType = [{ label: "Amount", value: "Amount", id: 1 }, { label: "Percentage", value: "Percentage", id: 2 }];
    // const [fillDis, setFillDis] = useState([...disType]);
    const [disValue, setDisValue] = useState(discountType?.value === 'Percentage' ? '%' : 'Rs');

    useEffect(() => {
        if (discountType?.value === 'Amount') {
            setDisValue('Rs');
            setMaxDiscountAmount();
        } else if (discountType?.value === 'Percentage') {
            setDisValue('%');
        }
    }, [discountType]);
    // const fillDisType = (e) => {
    //     const get = e
    //     const fill = disType.filter((itm) => itm.toLowerCase().includes(get.toLowerCase()))
    //     setFillDis(fill);
    // };
    // const addValue = (e) => {
    //     setDiscountType(e);
    //     setShowSuggestion(false);
    //     if (e === 'Amount') {
    //         setDisValue('Rs');
    //         setMaxDiscountAmount();
    //     } else if (e === 'Percentage') {
    //         setDisValue('%');
    //     }
    // };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Update Coupon</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">
                        <div className="add-form">

                            {/* NAME*/}
                            <div className="d-flex w-100 m-b2 d-other">

                                <div className="add ">
                                    <label>Coupon Code</label>
                                    <input
                                        type="text"
                                        value={couponCode}
                                        onChange={(e) => setCouponCode(e.target.value)}
                                    />
                                </div>
                                <div className="add ">
                                    <label>Min. Order Value</label>
                                    <input
                                        type="text"
                                        value={minOrderValue}
                                        onChange={(e) => { setMinOrderValue(e.target.value) }}
                                    />
                                </div>
                            </div>

                            {/* Mobile */}
                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <label>StartDate</label>
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={handelStartDate}
                                        className="date-input"
                                        min={stDate}
                                    />
                                </div>
                                <div className="add">
                                    <label>End Date</label>
                                    <input
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        className="date-input"
                                        min={content?.startDate || stDate}
                                    />
                                </div>
                            </div>
                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="referralCoupon"
                                            checked={shippingCoupon}
                                            onChange={() => setShippingCoupon(!shippingCoupon)}
                                            id="shippingCoupon"
                                        />
                                        <label htmlFor="shippingCoupon">Is Shipping Coupon ? </label>
                                    </div>
                                </div>
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="referralCoupon"
                                            checked={referralCoupon}
                                            onChange={() => setReferralCoupon(!referralCoupon)}
                                            id="check-box"
                                        />
                                        <label htmlFor="check-box">Is Referral Coupon ? </label>
                                    </div>
                                </div>
                            </div>

                            {/* email */}
                            {!shippingCoupon && <div className="d-flex w-100 m-b2 d-other">
                                <div className="add parentid">
                                    <label>Discount Type</label>
                                    {/* <input
                                        type="text"
                                        value={discountType}
                                        onChange={(e) => { setDiscountType(e.target.value); fillDisType(e.target.value) }}
                                        onFocus={() => setShowSuggestion(true)}
                                    />
                                    {
                                        showSuggestion && <div className="multiple-cat" ref={ref}>
                                            {
                                                fillDis.map((itm) => {
                                                    return (
                                                        <>
                                                            <div className="options">
                                                                <li onClick={() => { addValue(itm) }}>
                                                                    <p>{itm}</p>
                                                                </li>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            }
                                        </div>
                                    } */}
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={disType}
                                        value={discountType}
                                        defaultValue={disType?.[0]}
                                        onChange={(e) => { setDiscountType(e) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </div>
                                <div className="add">
                                    <label>Discount Value</label>
                                    <div className="btn-AddCat">
                                        <input
                                            type="text"
                                            value={discountValue}
                                            onChange={(e) => setDiscountValue(e.target.value)}
                                        />
                                        <button>{disValue}</button>
                                    </div>
                                </div>

                            </div>}

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <label>Max Used per person</label>
                                    <input
                                        type="text"
                                        value={maxUsePerUser}
                                        onChange={(e) => setMaxUsePerUser(e.target.value)}
                                    />
                                </div>

                                {
                                    !shippingCoupon && discountType?.value === 'Percentage' &&
                                    (
                                        <div className="add ">
                                            <label>Max. Discount Amount</label>
                                            <input
                                                type="text"
                                                value={maxDiscountAmount}
                                                onChange={(e) => { setMaxDiscountAmount(e.target.value) }}
                                            />
                                        </div>
                                    )
                                }
                            </div>

                            {/* <div className="d-flex w-100 m-b2 d-other">
                                {
                                    discountType === 'Percentage' &&
                                    <div className="add">
                                        <div className="d-flex check-box-avail">
                                            <input
                                                type="checkbox"
                                                name="referralCoupon"
                                                checked={referralCoupon}
                                                onChange={() => setReferralCoupon(!referralCoupon)}
                                                id="check-box"
                                            />
                                            <label htmlFor="check-box">Is Referral Coupon ? </label>
                                        </div>
                                    </div>
                                }
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="referralCoupon"
                                            checked={shippingCoupon}
                                            onChange={() => setShippingCoupon(!shippingCoupon)}
                                            id="shippingCoupon"
                                        />
                                        <label htmlFor="shippingCoupon">Is Shipping Coupon ? </label>
                                    </div>
                                </div>
                            </div> */}

                            <div className="editer m-b2">
                                {/* Jodit Editor */}
                                <div className="add w-100">
                                    <label>Description</label>

                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="btn submit-btn" style={{ justifyContent: "flex-start" }}>
                            <button onClick={() => members(product.uuid)}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessPopUp
                isOpen={showPop}
                action={action}
                navv={navv}
                FutherMore={more}
                onClose={onCloseBtn}
                onConfirm={confirmPopUp}
            />
        </>
    )
}
export default UpdateCoupon;